import { Button } from "@mui/material";
import { FC } from "react";
import { FiPlus } from "react-icons/fi";

interface TicketNewRequestActionProps {
  onClick: () => void;
}

export const TicketNewRequestAction: FC<TicketNewRequestActionProps> = ({
  onClick,
}) => {
  return (
    <Button
      variant="contained"
      color="primary"
      startIcon={<FiPlus />}
      onClick={onClick}
    >
      New request
    </Button>
  );
};
